
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcAreaGraph as ObcAreaGraphElement} from '@oicl/openbridge-webcomponents/dist/bars-graphs/area-graph/area-graph.js';
 
 
 

 
 export const ObcAreaGraph = createComponent({
   react: React,
   tagName: 'obc-area-graph',
   elementClass: ObcAreaGraphElement,
   events: {
     
   }
  });
 
 